// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__qZv+U","rotation":"loader_rotation__StSk-"};